export default __webpack_public_path__ + "dist/media/Sent.93164805.svg";